<template>
	<eg-modal
		height="300px"
		width="800px"
		:show="show"
		@close="modal = $event"
		persistent
	>
		<p slot="body">
			Obrigado por se cadastrar na Engelink! Em breve entraremos em
			contato por telefone para conhecer melhor sua empresa. Enquanto
			isso, navegue pelo nosso painel de cotações.
		</p>
		<a slot="footer" @click="$emit('close', false)" class="btn-flat"
			>Sair</a
		>
	</eg-modal>
</template>

<script>
export default {
    name: 'SupplierBlocked',
    props: {
        show: Boolean,
    },
};
</script>

<style></style>
